import renderHTML from 'react-render-html';

export const stripHtml = (html?: string) => {
  if (!html) return '';

  const htmlParsed = renderHTML(html);
  return htmlParsed || '';
};
